import React from 'react'
import Taxonomy1 from './Taxonomy1/Taxonomy1'
import Taxonomy2 from './Taxonomy2/Taxonomy2'
import Taxonomy3 from './Taxonomy3/Taxonomy3'
import styles from './styles.module.css'

function Taxonomy ({
  localTaxonomyLevel1,
  setLocalTaxonomyLevel1,
  localTaxonomyLevel2,
  setLocalTaxonomyLevel2,
  localTaxonomyLevel3,
  setLocalTaxonomyLevel3
}) {
  return (
    <div className={styles.containerTaxonomy}>
      <Taxonomy1
        localTaxonomyLevel1={localTaxonomyLevel1}
        setLocalTaxonomyLevel1={setLocalTaxonomyLevel1}
      />
      <Taxonomy2
        localTaxonomyLevel2={localTaxonomyLevel2}
        setLocalTaxonomyLevel2={setLocalTaxonomyLevel2}
      />
      <Taxonomy3 localTaxonomyLevel3={localTaxonomyLevel3} setLocalTaxonomyLevel3={setLocalTaxonomyLevel3} />
    </div>
  )
}

export default Taxonomy
